var kef_swiper_el = {}
var kef_swiper = {
  init: () => {
    var carousels = $('.kef-swiper');

    carousels.each(function(i) {
      var _this = $(this);
      var slider_id = _this.attr('data-id') || '';
      var slider_classtype = _this.attr('class') || '';
      var slider_classname = `kef-swiper-${i}`;

      _this.addClass(slider_classname);

      if (slider_classtype.indexOf('kef-cms-swiper') >= 0) {
        slider_id = 'kef-cms-swiper';
        var html = _this.html();
        _this.html(`<div class="swiper">
          <div class="swiper-wrapper">${html}</div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button swiper-button-prev"></div>
          <div class="swiper-button swiper-button-next"></div>
          <div class="swiper-scrollbar"></div>
        </div>`);
        // $('.swiper-wrapper > div', this).wrap('<div class="swiper-slide"></div>'); 
        $('.swiper-wrapper > div', this).addClass('swiper-slide'); 

      } else if (['kef-tab-pagination-swiper'].indexOf(slider_id) >= 0) {
        $('.swiper-slide', _this).each(function() {
          var slug = $(this).attr('data-text').toLowerCase()
            .replace(/ /g,'-')
            .replace(/[^\w-]+/g,'');
          $(this).attr('data-hash', slug);
        });
      }

      var slider_config = kef_swiper.getConfig(slider_id, `.${slider_classname}`);

      kef_swiper_el[i] = kef_swiper.initSwiper(`.${slider_classname}`, slider_config);

      kef_swiper.initVideoPlayer(kef_swiper_el[i], i);
    });

    $.each(kef_swiper_el, function(i) {
      var swiper_obj = kef_swiper_el[i];
      var slider_el = $(swiper_obj.el);
      var slider_id = slider_el.parent().attr('data-id');

      if (slider_id == 'kef-tab-pagination-content-swiper') {
        var prev_i = i - 1;
        kef_swiper_el[prev_i].on('slideChange', (swiper) => {
          var idx = kef_swiper_el[prev_i].activeIndex;
          kef_swiper_el[i].slideTo(idx, 0);

          var el = $(swiper.el);
          var pagination = $('.swiper-pagination', el);
          var bullet_active = $('.swiper-pagination-bullet-active', pagination);
          pagination.stop().animate({
            scrollLeft: bullet_active.offset().left - pagination.offset().left + pagination.scrollLeft(),
          }, 300);
        });
      } else if (slider_id == 'kef-tab-pagination-swiper') {
        slider_el.on('click', '.swiper-player-button', function(e) {
          if (! $(this).hasClass('pause')) {
            swiper_obj.autoplay.pause();
          } else {
            if (typeof swiper_obj.autoplay.run !== 'undefined') {
              swiper_obj.autoplay.run();
            } else if (typeof swiper_obj.autoplay.resume !== 'undefined') {
              swiper_obj.autoplay.resume();
            }
          }
          $(this).toggleClass('pause');
          slider_el.toggleClass('pause');
        });
        $(window).on('load hashchange', function() {
          kef_swiper.onHashChange(slider_el, swiper_obj);
        });
      }
    });
  },
  initSwiper: (classname, config) => {
    return new Swiper(`${classname} .swiper`, config);
  },
  getConfig: (slider_id, slider_classname) => {
    if (slider_id == 'kef-feature-card-swiper') {
      return {
        direction: 'horizontal',
        loop: false,
        spaceBetween: 10,
        slidesPerView: 1,
        freeMode: true,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: `${slider_classname} .swiper-button-next`,
          prevEl: `${slider_classname} .swiper-button-prev`,
        },
        pagination: {
          el: `${slider_classname} .swiper-pagination`,
          clickable: true,
        },
        scrollbar: {
          el: `${slider_classname} .swiper-scrollbar`,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          576: {
            spaceBetween: 20,
            slidesPerView: 2.5,
          },
          850: {
            spaceBetween: 20,
            slidesPerView: 3.5,
          },
        },
        on: {
          init: function(swiper) {
            var btn = $(`${slider_classname} .swiper-button-disabled`);
    
            btn.length == 2 ? btn.hide() : $(`${slider_classname} .swiper-button`).show();
          },
          resize: function(swiper) {
            var btn = $(`${slider_classname} .swiper-button-disabled`);
    
            btn.length == 2 ? btn.hide() : $(`${slider_classname} .swiper-button`).show();
          },
        },
      };
    } else if (slider_id == 'kef-cms-swiper') {
      var spaceBetween = [10, 20, 20]; // mb tb dt
      var defaultSpace = parseInt($(slider_classname+' .swiper-slide').css('marginRight').replace('px', ''));
      if (defaultSpace > 0 ) {
        spaceBetween = [defaultSpace, defaultSpace, defaultSpace];
      }
      return {
        direction: 'horizontal',
        loop: false,
        spaceBetween: spaceBetween[0],
        slidesPerView: 'auto',
        freeMode: true,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: `${slider_classname} .swiper-button-next`,
          prevEl: `${slider_classname} .swiper-button-prev`,
        },
        pagination: {
          el: `${slider_classname} .swiper-pagination`,
          clickable: true,
        },
        scrollbar: {
          el: `${slider_classname} .swiper-scrollbar`,
          hide: true,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          576: {
            spaceBetween: spaceBetween[1],
          },
          850: {
            spaceBetween: spaceBetween[2],
          },
        },
      };
    } else if (slider_id == 'kef-tab-pagination-swiper') {
      var delay = $(slider_classname).attr('data-autoplay-delay');
          delay = typeof delay !== 'undefined' ? delay : 7;
      var flag_player = $(slider_classname).attr('data-enable-player');
      var hash_slide = $(`.swiper-slide[data-hash="${decodeURI(window.location.hash.replace('#',''))}"]`);
      flag_player = typeof flag_player !== 'undefined' ? flag_player.toLowerCase() === 'true' : true;
      return {
        direction: 'horizontal',
        loop: false,
        spaceBetween: 0,
        slidesPerView: 1,
        effect: 'fade',
        noSwiping: true,
        noSwipingClass: `.swiper-slide`,
        initialSlide: hash_slide.length == 1 ? $(`${slider_classname} .swiper-slide`).index(hash_slide) : 0,
        autoplay: delay > 0 ? {
          delay: (delay * 1000),
          disableOnInteraction: false,
        } : false,
        navigation: {
          nextEl: `${slider_classname} .swiper-button-next`,
          prevEl: `${slider_classname} .swiper-button-prev`,
        },
        pagination: {
          el: `${slider_classname} .swiper-pagination`,
          clickable: true,
          renderBullet: function(index, className) {
            var bullet = $(`${slider_classname} .swiper-pagination-bullet`).get(index);
            if (typeof bullet !== 'undefined') return bullet.outerHTML;

            var slide = $(`${slider_classname} .swiper-slide`).get(index);
            var text = $(slide).attr('data-text')
            return `<div class="${className}">
              <span class="swiper-pagination-bullet-text">${text}</span>
              <span class="swiper-pagination-bullet-progressbar"></span>
            </div>`;
          }
        },
        scrollbar: {
          el: `${slider_classname} .swiper-scrollbar`,
        },
        on: {
          init: function(swiper) {
            $(`${slider_classname} .swiper-pagination-bullet-progressbar`).css({
              'animation-duration': `${delay}s`,
            });

            if (flag_player) {
              $(`${slider_classname} .swiper`).append(`<div class="swiper-wrapper-container"></div>`);
              $(`${slider_classname} .swiper-pagination`).appendTo(`${slider_classname} .swiper-wrapper-container`);
              $(`${slider_classname} .swiper-scrollbar`).appendTo(`${slider_classname} .swiper-wrapper-container`);
              $(`${slider_classname} .swiper-button-prev`).appendTo(`${slider_classname} .swiper-wrapper-container`);
              $(`${slider_classname} .swiper-button-next`).appendTo(`${slider_classname} .swiper-wrapper-container`);
              $(`${slider_classname} .swiper-wrapper-container`).append(`<div class="swiper-player">
                <button type="button" class="swiper-player-button" aria-label=""></button>
              </div>`);
            }
          },
        },
      };
    } else if (slider_id == 'kef-tab-pagination-content-swiper') {
      return {
        direction: 'horizontal',
        loop: false,
        spaceBetween: 0,
        slidesPerView: 1,
        effect: 'fade',
        autoHeight: true,
        navigation: {
          nextEl: `${slider_classname} .swiper-button-next`,
          prevEl: `${slider_classname} .swiper-button-prev`,
        },
        pagination: {
          el: `${slider_classname} .swiper-pagination`,
          clickable: true,
        },
        scrollbar: {
          el: `${slider_classname} .swiper-scrollbar`,
        },
      };
    }

    return {}
  },
  onHashChange: (slider_el, swiper_obj) => {
    var hash = window.location.hash.replace('#', ''),
        slide = $(`[data-hash="${hash}"]`, slider_el);
    if (hash != '' && slide.length == 1) {
      $('html,body').stop().animate({
        scrollTop: slider_el.offset().top - $('#header').outerHeight(),
      }, 300);

      var idx = $(`.swiper-slide`, slider_el).index(slide);
      swiper_obj.slideTo(idx, 0);
    }
  },
  initVideoPlayer: (swiper_obj, i) => {
    var slider_el = $(swiper_obj.el),
        video_player_box = $('.video-player-box', slider_el);

    if (video_player_box.length == 0) return;

    // init video-worker
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/video-worker@2/dist/video-worker.min.js';
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);

    script.onload = function() {
      var script2 = document.createElement('script');
      script2.src = window.kef.assets.video_worker.js;
      script2.type = 'text/javascript';
      document.getElementsByTagName('head')[0].appendChild(script2);

      script2.onload = function() {
        video_player.init();

        $('.video-player-box .btn-play', slider_el).on('click', function(e) {
          var vid = $(this);
          video_player.stopAll();
          video_player.play(vid);
          e.preventDefault();
        });
        
        swiper_obj.on('slideChange', (swiper) => {
          video_player.stopAll();

          var active_slide = $(swiper.slides[swiper.activeIndex]);
          var slide_video_player = $('.video-player', active_slide);
          if (slide_video_player.length > 0) {
            video_player.play(slide_video_player);
          }
        });
      }
    }
  },
}
kef_swiper.init();